import { render, staticRenderFns } from "./DeviceStatus.vue?vue&type=template&id=35b20034&scoped=true&"
import script from "./DeviceStatus.vue?vue&type=script&lang=js&"
export * from "./DeviceStatus.vue?vue&type=script&lang=js&"
import style0 from "./DeviceStatus.vue?vue&type=style&index=0&id=35b20034&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b20034",
  null
  
)

export default component.exports